export const FINAL_SALARY_LABEL_KEY = 'DEAL_PAYROLL_FINAL_SALARY';
export const FINAL_CURRENCIES_LABEL_KEY = 'DEAL_PAYROLL_FINAL_SALARY_CURRENCIES';
export const PREVIEW_SALARY_LABEL_KEY = 'DEAL_PAYROLL_PREVIEW_FINAL_SALARY';
export const PREVIEW_CURRENCIES_LABEL_KEY = 'DEAL_PAYROLL_PREVIEW_FINAL_SALARY_CURRENCIES';
export const PREVIEW_WARNING_KEY = 'DEAL_PAYROLL_PARTIAL_PREVIEW_WARNING';

export const FORMULA_ID_PREFIX = 'deal-payroll-formula-';
export const DETAIL_ESCAPE_KEY = 'Escape';
export const DETAIL_LEGACY_ESCAPE_KEY = 'Esc';
export const DETAILS_OPEN_ATTRIBUTE = 'open';
export const FUNCTION_TYPE = 'function';

export const PLANFIX_TASK_URL_PREFIX = 'https://cuby.planfix.com/task/';
export const CHECKLIST_UNIT_TYPE = 'CHECKLIST';
export const MINIMUM_PLANNED_HOURS = 0;
export const DEFAULT_TASK_RULE = 'DEFAULT_FIXED';
export const DEFAULT_TASK_RULE_ISSUE = 'PROCESS_RULE_DEFAULTED';
export const UNCLASSIFIED_TASK_GROUP = 'UNCLASSIFIED';
export const TASK_GROUP_KEY_SEPARATOR = ':';
export const GLOBAL_ISSUE_SCOPE = 'global';
export const UNCLASSIFIED_GROUP_KEY = 'DEAL_PAYROLL_UNCLASSIFIED_GROUP';
export const STANDARD_TASKS_GROUP_KEY = 'DEAL_PAYROLL_STANDARD_TASKS';
export const FIRST_INDEX = 0;
export const EMPTY_COUNT = 0;
export const EMPTY_VALUE = '';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-working-report/deal-payroll-detail/deal-payroll-detail.view.constants.ts